export function getLocation(state) {
  return state.location.list;
}
